export default class ScrollIntoView {
	constructor({ elements }) {
		elements.forEach((el) => {
			const targetElement = document.getElementById(`${el.dataset.scrollIntoView}`);
			el.addEventListener('click', (e) => {
				e.preventDefault();
				try {
					targetElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
				} catch {
					targetElement.scrollIntoView(false);
				}
			});
		});
	}
}
